import { versionRows } from '@/mocks/filmData';

export default function VersionCompare() {
  return (
    <section id="versions" className="scroll-mt-20 bg-background-100">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
            <i className="ri-file-list-3-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="text-xs font-medium tracking-widest text-secondary-700 uppercase">Compare</span>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">四种常见版本对照</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          把语言呈现、适合人群与阅读负担放在一起比较，更容易找到与你观看习惯匹配的那一个版本。
        </p>

        {/* Desktop table */}
        <div className="hidden md:block mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="bg-foreground-950 text-background-50">
                <th scope="col" className="px-5 py-4 font-heading font-semibold whitespace-nowrap">版本</th>
                <th scope="col" className="px-5 py-4 font-heading font-semibold whitespace-nowrap">语言呈现</th>
                <th scope="col" className="px-5 py-4 font-heading font-semibold whitespace-nowrap">适合人群</th>
                <th scope="col" className="px-5 py-4 font-heading font-semibold whitespace-nowrap">阅读负担</th>
                <th scope="col" className="px-5 py-4 font-heading font-semibold">说明</th>
              </tr>
            </thead>
            <tbody>
              {versionRows.map((row, i) => (
                <tr key={row.name} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}>
                  <td className="px-5 py-4 font-medium text-foreground-950 whitespace-nowrap">{row.name}</td>
                  <td className="px-5 py-4 text-foreground-700 whitespace-nowrap">{row.language}</td>
                  <td className="px-5 py-4 text-foreground-700 whitespace-nowrap">{row.audience}</td>
                  <td className="px-5 py-4">
                    <span className="px-2.5 py-1 rounded-full text-xs bg-accent-100 text-accent-900 whitespace-nowrap">
                      {row.effort}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-foreground-600 leading-relaxed">{row.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden mt-8 space-y-3">
          {versionRows.map((row) => (
            <div key={row.name} className="rounded-lg bg-background-50 border border-background-200 p-4">
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading font-semibold text-base text-foreground-950">{row.name}</h3>
                <span className="px-2.5 py-1 rounded-full text-[11px] bg-accent-100 text-accent-900 whitespace-nowrap">
                  {row.effort}
                </span>
              </div>
              <dl className="mt-3 space-y-1.5 text-xs">
                <div className="flex gap-2">
                  <dt className="text-foreground-500 w-16 shrink-0">语言呈现</dt>
                  <dd className="text-foreground-700">{row.language}</dd>
                </div>
                <div className="flex gap-2">
                  <dt className="text-foreground-500 w-16 shrink-0">适合人群</dt>
                  <dd className="text-foreground-700">{row.audience}</dd>
                </div>
              </dl>
              <p className="mt-3 text-xs text-foreground-600 leading-relaxed">{row.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}